import styled from 'styled-components';
export var visuallyHiddenTextStyle = "\n  clip-path: inset(100%);\n  clip: rect(1px, 1px, 1px, 1px);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  width: 1px;\n  margin: 0;\n";
var VisuallyHiddenText = /*#__PURE__*/styled.span.withConfig({
  displayName: "VisuallyHiddenText",
  componentId: "sc-1yjwwa5-0"
})(["", ";"], visuallyHiddenTextStyle);
export default VisuallyHiddenText;